<template>
  <Modal v-model="show" :title="'结算信息编辑'" :mask-closable="false" :closable='false' width="760">
    <Form :model="form" ref="form" :rules="rules" :label-width="120" inline>
	  <FormItem label="受理部门：" prop="acceptanceDept">
	    <Input type="text" placeholder="请输入" v-model="form.acceptanceDept" style="width: 530px"></Input>
	  </FormItem>
      <FormItem label="联系人:" prop="contactsIdList">
        <Select v-model="form.contactsIdList" multiple style="width:530px">
          <Option v-for="item in contactsData" :value="item.value" :key="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="结算方式:" prop="settlementMethodList">
        <CheckboxGroup v-model="form.settlementMethodList" style="width:530px">
          <Checkbox :label="item.value" border v-for="item in settlementMethodData">{{item.name}}</Checkbox>
        </CheckboxGroup>
      </FormItem>
	  <FormItem label="其他结算方式：" v-if="form.settlementMethodList && form.settlementMethodList.indexOf(5) > -1">
	    <Input type="text" placeholder="请输入" v-model="form.otherSettlementMethod" style="width: 530px"></Input>
	  </FormItem>
      <FormItem label="结款流程:" prop="paymentProcess">
        <Input v-model="form.paymentProcess" type="textarea" :maxlength="200" placeholder="请输入" style="width: 530px"></Input>
      </FormItem>
	  <Row>
	    <Col span="8">
	    <FormItem label="结款流程附件:">
	      <Upload ref="upload" :show-upload-list="false" multiple type="drag" style="width: 90px" :accept="accept" :data="uploadDataJKLC" :format='format' :on-success="handleSuccessJKLC" :on-format-error="handleFormatErrorJKLC"
	        :action="$constDefinition.baseUrl+'/File/UploadByCustomer'">
	        <div style="padding: 10px 0">
	          <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
	          <p>上传文件</p>
	        </div>
	      </Upload>
	    </FormItem>
	    </Col>
	    <Col span="14">
	    <!-- 文件列表 -->
	    <div class="fileList" v-if="form.结款流程_Files.length>0">
	      <template v-for="(img, img_i) in form.结款流程_Files">
	        <span :key="img_i" class="img_wrap">
	          <span class="pos">
	            <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
	            <i class="img_magnify">
	              <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemoveJKLC(img_i,img.fileGuids)" type="ios-trash-outline" />
	              <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'结款流程')" type="md-arrow-down" />
	            </i>
	          </span>
	          <span class="filename" :title="img.fileName">{{img.fileName}}</span>
	        </span>
	      </template>
	    </div>
	    </Col>
	  </Row>
	  
      <Row>
        <Col span="8">
        <FormItem label="流程图:" prop="流程图_Files">
          <Upload ref="upload" :show-upload-list="false" multiple type="drag" style="width: 90px" :accept="accept" :data="uploadDataLCT" :format='format' :on-success="handleSuccess" :on-format-error="handleFormatError"
            :action="$constDefinition.baseUrl+'/File/UploadByCustomer'">
            <div style="padding: 10px 0">
              <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
              <p>上传文件</p>
            </div>
          </Upload>
        </FormItem>
        </Col>
        <Col span="14">
        <!-- 文件列表 -->
        <div class="fileList" v-if="form.流程图_Files.length>0">
          <template v-for="(img, img_i) in form.流程图_Files">
            <span :key="img_i" class="img_wrap">
              <span class="pos">
                <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemove(img_i,img.fileGuids)" type="ios-trash-outline" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'流程图')" type="md-arrow-down" />
                </i>
              </span>
              <span class="filename" :title="img.fileName">{{img.fileName}}</span>
            </span>
          </template>
        </div>
        </Col>
      </Row>

    </Form>
    <Spin size="large" fix v-show="spinShow"></Spin>
    <div slot="footer">
      <Button @click="close()" class="close-btn">关闭</Button>
      <Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn" v-if="!isDisable">提交</Button>
    </div>
  </Modal>
</template>
<script>
import Ajax from '../../../lib/ajax'
import selectTree from '../../../components/selectTree/selectTree.vue'
export default {
  name: 'CreateSettlement',
  components: {
    selectTree,
  },
  props: {
    show: Boolean, //弹窗 窗口显示
    customerId: Number,
    quotationId: Number,
	isDetail:Boolean
  },
  data() {
    return {
      accept: '.doc,.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF,.PNG,.EXCEL,.WORD,.PDF,.excel,.excl,.xlsx,.xls,.word,.docx,.pdf',
	  format: ['doc','docx','xlsx','xls','jpg', 'pdf', 'png', 'jpeg','vsdx'],
      form: {
        signingMode: null,
        signingCycle: null,
        payType: null,
        accountPeriod: null,
        流程图_Files: [],
        结款流程_Files: [],
        contactsIdList: [],
        warrantyTerms: '',
        annualAgreementOpinion: '',
        contractOpinion: '',
        customerId: this.customerId,
        id: this.quotationId,
      },
      rules: {
        signingMode: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'number' },
        ],
        contactsIdList: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
        ],
        settlementMethodList: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
        ],
        paymentProcess: [
          { required: false, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        acceptanceDept: [
          { required: true, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        流程图_Files: [
          { required: false, message: '请上传文件', trigger: 'blur,change', type: 'array' },
        ],
      },
      uploadDataLCT: {
        id: this.customerId,
        type: this.$constDefinition['结算信息_流程图'],
      },
	  uploadDataJKLC: {
	    id: this.customerId,
	    type: this.$constDefinition['结算信息_结款流程'],
	  },
	  isDisable:false,
      settlementMethodData: [], //
      treeData: [],
      contactsData: [], //list
      spinShow: false,
    }
  },
  mounted() {
    if (this.customerId) {
      this.spinShow = true
      this.getUser()
    }
    if (this.quotationId) {
      this.getDetail()
    }
	if(this.isDetail){
		this.isDisable=this.isDetail
		}
  },
  methods: {
    // 关闭弹窗
    close(refresh) {
      this.form = {
        signingMode: null,
        signingCycle: null,
        payType: null,
        accountPeriod: null,
        流程图_Files: [],
        结款流程_Files: [],
        contactsIdList: [],
        warrantyTerms: '',
        annualAgreementOpinion: '',
        contractOpinion: '',
        customerId: this.customerId,
        id: 0,
      }
      this.$refs['form'].resetFields()
      this.$emit('close', refresh)
    },
    //   提交记录
    submit() {
      let _this = this
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let files = []
          let files2 = []
          if (_this.form.流程图_Files.length > 0) {
            _this.form.流程图_Files.map((file) => {
              files.push(file.fileGuids)
            })
            _this.form.flowChartGuidList = files
          }
		  if (_this.form.结款流程_Files.length > 0) {
		    _this.form.结款流程_Files.map((file) => {
		      files2.push(file.fileGuids)
		    })
		    _this.form.paymentProcessGuidList = files2
		  }
          this.spinShow = true
          var url = ''
          if (this.form.id != null && this.form.id != 0) {
            url = '/api/services/app/CustomerSettlementApiService/Update'
            let { data } = await this.$Ajax.put(url, this.form)
            if (data.success) {
              this.$Message.success({
                content: '编辑成功',
              })
              _this.close(true)
            }
          } else {
            url = '/api/services/app/CustomerSettlementApiService/Create'
            let { data } = await this.$Ajax.post(url, this.form)
            if (data.success) {
              this.$Message.success({
                content: '新建成功',
              })
              _this.close(true)
            }
          }
          this.spinShow = false
        }
      })
    },
    //   获取下拉框数据
    async getUser() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerSettlementApiService/GetSettlementMgrInitData?customerId=${this.customerId}`
      )
      this.contactsData = data.result.contactsData
      this.settlementMethodData = data.result.settlementMethodData
      this.getTree()
      this.spinShow = false
    },
    async getTree() {
      let reponse = await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree')
      // reponse.data.result[0].expand = true;
      let dataResult = reponse.data.result
      console.log(dataResult)
      // let respone = this.$store.state.department.departmentTree;
      this.editeTreeValue(dataResult)
      this.treeData = dataResult
    },
    selectChange(data) {
      this.form.acceptanceDept = data
    },
    removeRoot(data) {
      this.form.acceptanceDept = data
    },
    editeTreeValue(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].title = data[i].displayName
        data[i].value = data[i].id
        if (data[i].children) {
          if (data[i].children.length > 0) {
            data[i].expand = true
          }
          this.editeTreeValue(data[i].children)
        }
      }
    },
    async getDetail() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerSettlementApiService/GetDetailById?id=${this.quotationId}`
      )
      this.form = data.result
      this.spinShow = false
      this.getTree()
    },
    //文件上传成功
    handleSuccess(e) {
      this.form.流程图_Files.push(e.result)
      this.$refs.form.validateField('流程图_Files')
      // this.$refs.upload.clearFiles()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式错误',
        // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    handleDownload(id, name, type) {
      let fileExtension,
        fileParts = null
      if (name.indexOf('.') > -1) {
        fileParts = name.split('.')
        fileExtension = '.' + fileParts[fileParts.length - 1]
      }
      this.$downLoad(`/files/downloadFile_Path/${id}`, type, fileExtension)
    },
    //移除文件
    async handleRemove(index, guid) {
      try {
        const { data } = await this.$Ajax.delete(
          `/api/services/app/ComFile/DeleteFileByGuid?guid=${guid}`
        )
        this.form.流程图_Files.splice(index, 1)
      } catch (error) {
        this.$Message.error({
          content: '删除失败',
        })
      }
    },
	
	
	//文件上传成功
	handleSuccessJKLC(e) {
	  this.form.结款流程_Files.push(e.result)
	  this.$refs.form.validateField('结款流程_Files')
	  // this.$refs.upload.clearFiles()
	},
	//文件格式错误
	handleFormatErrorJKLC(file) {
	  this.$Notice.warning({
	    title: '文件格式错误',
	    // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
	  })
	},
	//移除文件
	async handleRemoveJKLC(index, guid) {
	  try {
	    const { data } = await this.$Ajax.delete(
	      `/api/services/app/ComFile/DeleteFileByGuid?guid=${guid}`
	    )
	    this.form.结款流程_Files.splice(index, 1)
	  } catch (error) {
	    this.$Message.error({
	      content: '删除失败',
	    })
	  }
	},
  },
}
</script>
<style lang="less" scoped>
.fileList {
  display: flex;
  flex-wrap: wrap;
  .filename {
    width: 80px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  cursor: pointer;
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 85px;
  height: 85px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
}
.img_wrap {
  display: flex;
  flex-direction: column;
  padding: 0px 0px;
}
/deep/.ivu-input[type='radio'] {
  width: 20px !important;
}
</style>